'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useContext } from 'react';

import cx from 'classnames';

import ButtonCTA from 'components/ui/ButtonCTA';
import ButtonCircle from 'components/ui/ButtonCircle';
import carouselContext from 'components/ui/CarouselProvider/CarouselContext';
import Text from 'components/ui/Text';

import CarouselShowcaseSlide from './CarouselShowcaseSlide';
import GradientPanel from './GradientPanel';

import styles from './BlockCarouselShowcase.module.scss';

const CarouselShowcase = () => {
    const context = useContext(carouselContext);

    return (
        <section className={cx(styles.root)}>
            <div className={styles.bg} role="presentation">
                {context.slides?.map((slide, i) => (
                    <GradientPanel
                        key={i}
                        {...slide}
                        isActive={context.activeIndex === i}
                        isPrev={context.prevIndex === i}
                    />
                ))}
            </div>
            <div className={styles.inner}>
                {context.slides?.map((slide, i) => (
                    <CarouselShowcaseSlide
                        key={i}
                        {...slide}
                        isActive={context.activeIndex === i}
                        isPrev={context.prevIndex === i}
                    />
                ))}
                <div className={styles.column}>
                    <div className={styles.ctaLockup}>
                        <div className={styles.buttonWrapper}>
                            {context.slides?.[context.activeIndex]?.cta && (
                                <ButtonCTA
                                    {...context.slides?.[context.activeIndex]
                                        ?.cta}
                                />
                            )}
                        </div>
                        <div className={styles.nav}>
                            <ButtonCircle
                                onClick={context.prevSlide}
                                className={styles.navItem}
                                theme="small-fill-white"
                                iconType="chevronLeft"
                            >
                                <span className="sr-only">Previous Slide</span>
                            </ButtonCircle>
                            <Text
                                baseTheme="labelSmall"
                                className={styles.navCount}
                            >
                                {`${context.activeIndex + 1}/${
                                    context.totalSlides
                                }`}
                            </Text>
                            <ButtonCircle
                                onClick={context.nextSlide}
                                className={styles.navItem}
                                theme="small-fill-white"
                                iconType="chevronRight"
                            >
                                <span className="sr-only">Next Slide</span>
                            </ButtonCircle>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CarouselShowcase;
